import React from 'react';
import Link from 'next/link';
import styles from './JobCard.module.css';
import { TranslatableLabel } from '@/components/TranslatableText';

interface JobCardProps {
  job: {
    id: number;
    title: string;
    slug?: string;
    company: string;
    location: string;
    salary?: string;
    type?: string;
    isPremium?: boolean;
    postedAt?: string;
    logo?: string;
  };
  lang?: string;
}

export default function JobCard({ job, lang = 'sq' }: JobCardProps) {
  const formatSalary = (salaryStr?: string) => {
    if (!salaryStr) return '';
    return salaryStr.replace(/\bA\b/g, 'ALL').replace(/\s+A$/, ' ALL');
  };

  return (
    <Link href={`/${lang}/vacancies/${job.slug || job.id}`} className={`${styles.card} ${job.isPremium ? styles.premium : ''}`}>
      <div className={styles.header}>
        <div className={styles.logo}>
          {job.logo?.startsWith('http') || job.logo?.startsWith('/') || job.logo?.startsWith('data:image') || (job.logo && job.logo.length > 200) ? (
            <img 
              src={job.logo?.startsWith('http') || job.logo?.startsWith('/') || job.logo?.startsWith('data:image') ? job.logo : `data:image/jpeg;base64,${job.logo}`} 
              alt={job.company} 
              style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: 'inherit' }} 
            />
          ) : (
            job.logo || '🏢'
          )}
        </div>
        <div className={styles.companyInfo}>
          <p className={styles.companyName}>{job.company}</p>
          <p className={styles.location}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '14px', height: '14px', marginRight: '4px', flexShrink: 0, opacity: 0.6 }}>
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
            {job.location}
          </p>
        </div>
      </div>
      
      <div className={styles.title}>
        {job.title}
      </div>
      
      <div className={styles.details}>
        <div className={styles.detailItem}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '16px', height: '16px', flexShrink: 0, opacity: 0.7 }}>
            <rect x="2" y="4" width="20" height="16" rx="2"></rect>
            <line x1="2" y1="10" x2="22" y2="10"></line>
          </svg>
          {formatSalary(job.salary)}
        </div>
        <div className={styles.detailItem}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '16px', height: '16px', flexShrink: 0, opacity: 0.7 }}>
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
          {job.type && <TranslatableLabel translationKey={job.type} />}
        </div>
        <div className={styles.detailItem}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '16px', height: '16px', flexShrink: 0, opacity: 0.7 }}>
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
          </svg>
          <TranslatableLabel translationKey="On-site" />
        </div>
      </div>
    </Link>
  );
}
